<section class="faq-section section-padding vw-100 overflow-hidden" [ngClass]="{'pt-0': isPage}">
  <div class="container" style="max-width: 900px">
    <span class="section-subtitle-pill bg-4">Assistance & Guidance</span>
    <h2 class="heading-color-1 section-title mt-2 mb-3">Frequently Asked Questions</h2>
    <p class="fs-15 pb-3">This series of frequently asked questions (FAQs) is intended to assist in the general understanding of the concept of Beneficial Ownership, otherwise referred to as Persons with Significant Control (PSC) in Nigeria legal framework. </p>
    <p class="fs-15 pb-5">It neither constitutes legal advice nor can it be construed to define, limit or otherwise restrict the Corporate Affairs Commission in the lawful fulfilment of its obligations. </p>

    <ul class="faq-list">
      @for (faq of faqs; track faq.question) {
        <li class="faq-item" [ngClass]="{'active': (activeFaq() === faq.question)}">
          <div class="question" role="button" (click)="activeFaq.set(faq.question)">
            <h3 class="heading-font heading-color-1 fs-18 fw-medium"
                [ngClass]="{'opacity-60p': !(activeFaq() === faq.question)}"
            >{{ faq.question }}</h3>
            @if (!(activeFaq() === faq.question)) {
              <iconify [name]="'lucide:chevron-down'" />
            } @else {
              <iconify [name]="'lucide:chevron-up'" />
            }
          </div>
          <p class="answer">{{ faq.answer }}</p>
        </li>
      }
    </ul>
  </div>
</section>
